import React from 'react';
import Script from 'next/script';
import { I26PeopleIncRecipeSearchProps } from './I26PeopleIncRecipeSearch.types';
import { translationClasses } from 'shared/TranslationClasses';
import { useCustomSitecoreContext } from 'shared/useCustomSitecoreContext';
import { SwitchToPreviewMessage } from 'shared/SwitchToPreviewMessage';
import { PromptForMissingDatasource } from 'shared/PromptForMissingDatasource';
import { useCreateMarketingRenderingHame } from 'shared/useCreateMarketingRenderingName';
import { ContentContainer, Text } from '@ahc-digital/component-library';
import { Text as JSSText } from '@sitecore-jss/sitecore-jss-nextjs';

export const Default = (props: I26PeopleIncRecipeSearchProps): JSX.Element => {
  const context = useCustomSitecoreContext();
  const isEditing = context?.pageEditing ?? false;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource) {
    return <PromptForMissingDatasource rendering={props?.rendering} />;
  }

  const { InstanceId } = props?.fields ?? {};
  const instanceId = InstanceId?.value?.trim();

  if (isEditing) {
    return (
      <SwitchToPreviewMessage componentName={props?.rendering?.componentName}>
        <ContentContainer>
          <Text tag="p" fontStyle="smParagraphBold">
            InstanceId: <JSSText field={InstanceId} />
          </Text>
        </ContentContainer>
      </SwitchToPreviewMessage>
    );
  }

  return (
    <>
      <Script
        id="mcl-raas-script"
        data-bundle={`https://raas.meredithcontentlicensing.com/v1/recipe-search.js?instanceId=${instanceId}`}
      >
        {`
          !function(){function e(e,n){n=n||{bubbles:!1,cancelable:!1,detail:void 0};var t=document.createEvent("CustomEvent");return t.initCustomEvent(e,n.bubbles,n.cancelable,n.detail),t}"function"!=typeof window.CustomEvent&&(e.prototype=window.Event.prototype,window.CustomEvent=e)}(),function(){function e(e){window.console&&window.console.log&&console.log(e)}function n(n){var o=document.createElement("p");o.textContent="We're sorry, but we're having trouble with our recipe search at the moment. Please check back later—we hope to have this issue fixed soon!",o.style.paddingTop="3rem",o.style.paddingRight="3rem",o.style.paddingBottom="3rem",o.style.paddingLeft="3rem",o.style.backgroundColor="#fff3d9",t.appendChild(o),o.style.marginTop="3rem",o.style.marginRight="1rem",o.style.marginLeft="1rem",e(n)}var t=document.getElementById("mcl-content");if(t.style.minHeight=window.innerHeight+"px",t)try{var o=document.createElement("script");o.src="https://raas.meredithcontentlicensing.com/v1/recipe-search.js?instanceId=${instanceId}",o.onload=function(){if(window.MCLRAAS&&window.MCLRAAS.init){var e=window.MCLRAAS.init(),t=!1,o=(e.addListener("/pageview/detail",(function(e){if(window.MCLRAAS.appProps.find((function(e){return"enableBasketful"==e.id&&e.isEnabled})))if(t)window.basketful.configureRecipeButtons();else{var n=document.createElement("script");n.onload=function(){t=!0},n.src="https://bonsai.basketful.co/basketful.js",document.head.append(n)}})),new CustomEvent("raaSLoaded",{detail:window.MCLRAAS}));document.dispatchEvent(o)}else n("MCL Error: RaaS not initialized correctly.")},o.onerror=function(){n("MCL Error: RaaS not responding. UI bundle unavailable.")},document.getElementsByTagName("head")[0].appendChild(o)}catch(t){n("MCL Error: RaaS not responding. UI bundle unavailable."),e(t)}else e('MCL Error: Page must include an empty div with an id of "mcl-content".')}();
        `}
      </Script>
      <div
        id="mcl-content"
        className={translationClasses(props?.params)}
        data-component={marketingRenderingName}
      />
    </>
  );
};
